export default "__VITE_ASSET__ByBN2qxk__"